import { ParamsService } from '../services'

const getCountries = () => {
  return new Promise(async (resolve, reject) => {
    await ParamsService.getCountries()
      .then(response => resolve(response.data))
      .then(err => reject({ error: true }))
  })
}
export default getCountries